import React from "react";
import Icon, { IconProps } from "@mui/material/Icon";
import { AttentionIcon } from "../Icons/AttentionIcon";

export type EmtIconProps = IconProps & {
  nonce?: string;
  onResizeCapture?: any;
  onResize?: any;
};

export const EmtIcon: JSX.Element & any = React.forwardRef<
  HTMLSpanElement,
  EmtIconProps
>((componentProps, ref) => {
  const { baseClassName, ...rest } = componentProps;
  return typeof rest.className === "string" &&
    rest.className.includes("emt-attention") ? (
    <AttentionIcon ref={ref as React.ForwardedRef<any>} />
  ) : (
    <Icon
      ref={ref}
      baseClassName={baseClassName ? baseClassName : "emt-icons"}
      {...rest}
    />
  );
});

EmtIcon.displayName = "EmtIcon";
